export interface ConfigState {
	config: any
}

export const initialConfigState: ConfigState = {
	config: null
}